var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4714 3.08838H8.23569C5.39291 3.08838 3.08838 5.39291 3.08838 8.23569V16.4714C3.08838 19.3141 5.39291 21.6187 8.23569 21.6187H16.4714C19.3141 21.6187 21.6187 19.3141 21.6187 16.4714V8.23569C21.6187 5.39291 19.3141 3.08838 16.4714 3.08838ZM19.8171 16.4714C19.8115 18.3168 18.3168 19.8115 16.4714 19.8171H8.23569C6.39022 19.8115 4.89559 18.3168 4.88994 16.4714V8.23569C4.89559 6.39022 6.39022 4.89559 8.23569 4.88994H16.4714C18.3168 4.89559 19.8115 6.39022 19.8171 8.23569V16.4714ZM17.2435 8.49305C17.812 8.49305 18.2729 8.03214 18.2729 7.46359C18.2729 6.89504 17.812 6.43413 17.2435 6.43413C16.6749 6.43413 16.214 6.89504 16.214 7.46359C16.214 8.03214 16.6749 8.49305 17.2435 8.49305ZM12.3535 7.72095C9.79503 7.72095 7.72095 9.79503 7.72095 12.3535C7.72095 14.9121 9.79503 16.9861 12.3535 16.9861C14.9121 16.9861 16.9861 14.9121 16.9861 12.3535C16.9889 11.124 16.5016 9.94415 15.6323 9.07478C14.7629 8.20541 13.583 7.71822 12.3535 7.72095ZM9.52251 12.3535C9.52251 13.9171 10.79 15.1846 12.3535 15.1846C13.9171 15.1846 15.1846 13.9171 15.1846 12.3535C15.1846 10.79 13.9171 9.52251 12.3535 9.52251C10.79 9.52251 9.52251 10.79 9.52251 12.3535Z",
    fill: "#FFF0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.0502d349cd3b42a033c235efa034b7bf.svg";
export { ForwardRef as ReactComponent };